module.exports = __webpack_public_path__ + "img/logo-colored.313851d0.svg";